import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, useParams, Navigate, useNavigate } from 'react-router-dom';

// Expose React + ReactDOM globally — components use window.X self-registration
// pattern inherited from original prototype. Must be set BEFORE dynamic imports.
window.React = React;
window.ReactDOM = ReactDOM;

async function boot() {
  // Data files self-register on window: WORKPLACES, FUNNELS, AVATARS, getFunnel, buildFields, FAQS.
  await import('./data.js');
  // Components self-register on window: Mechanism, LandingPage, CampaignHQ, TweaksPanel, HomePage.
  await import('./components/Mechanism.jsx');
  await import('./components/Landing.jsx');
  await import('./components/CampaignHQ.jsx');
  await import('./components/TweaksPanel.jsx');
  await import('./components/EduChat.jsx');
  await import('./components/Home.jsx');

  const { SLUG_MAP } = await import('./slug-map.js');

  function LandingRoute() {
    const { funnel: slug } = useParams();
    const navigate = useNavigate();
    const entry = SLUG_MAP[slug];
    if (!entry) return <Navigate to="/" replace />;
    const ctx = window.getFunnel(entry.workplaceId, entry.avatar);
    if (!ctx) return <Navigate to="/" replace />;
    const LandingPage = window.LandingPage;
    return (
      <LandingPage
        funnel={ctx.funnel}
        workplace={ctx.workplace}
        tweaks={{ density: 'comfortable', font: 'default' }}
        onOptIn={(values) => {
          sessionStorage.setItem(`hw-submission-${slug}`, JSON.stringify(values));
          navigate(`/${slug}/hq`);
        }}
      />
    );
  }

  function HqRoute() {
    const { funnel: slug } = useParams();
    const navigate = useNavigate();
    const entry = SLUG_MAP[slug];
    if (!entry) return <Navigate to="/" replace />;
    const ctx = window.getFunnel(entry.workplaceId, entry.avatar);
    if (!ctx) return <Navigate to="/" replace />;
    const submission = JSON.parse(sessionStorage.getItem(`hw-submission-${slug}`) || '{}');
    const CampaignHQ = window.CampaignHQ;
    return (
      <CampaignHQ
        funnel={ctx.funnel}
        workplace={ctx.workplace}
        submission={submission}
        onBack={() => navigate(`/${slug}`)}
      />
    );
  }

  function HomeRoute() {
    const navigate = useNavigate();
    const HomePage = window.HomePage;
    return <HomePage navigate={navigate} />;
  }

  function App() {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomeRoute />} />
          <Route path="/:funnel" element={<LandingRoute />} />
          <Route path="/:funnel/hq" element={<HqRoute />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    );
  }

  ReactDOM.createRoot(document.getElementById('root')).render(<App />);
}

boot().catch((err) => {
  console.error('Boot failed:', err);
  document.getElementById('root').innerHTML = `<div style="padding:2rem;color:#b8431f;font-family:Inter">Boot failed: ${err.message}</div>`;
});
